import { createAction } from "redux-actions";

export const showGlobalModal = createAction("MODAL_SHOW");
export const hideGlobalModal = createAction("MODAL_HIDE");
